import type { FC } from 'react';
import { Box, Typography } from '@mui/material';

import type { CommentTopic } from 'src/types/dashboard';

import SentimentIcon from './SentimentIcon';

import { styles } from './index.styles';

interface CommentTopicProps {
  topic: CommentTopic;
}

const CommentTopicBox: FC<CommentTopicProps> = ({ topic }) => (
  <Box sx={styles.commentTopic}>
    <Box>
      <Typography
        variant="caption"
        sx={{
          whiteSpace: 'nowrap',
        }}
      >
        {topic.category}
      </Typography>
      <Typography sx={styles.commentTopicLabel}>{topic.label}</Typography>
    </Box>
    <Box sx={styles.sentimentIcon}>
      <SentimentIcon sentiment={topic.sentiment} />
    </Box>
  </Box>
);

export default CommentTopicBox;
